/* RESPONSIBLE TEAM: team-inbox */

/**
 * Parses a newline-separated list of "monitorId:value" pairs and returns the value
 * matching the given monitorId. Handles colons in values (e.g. UUIDs).
 */
export function getValueFromMonitorPairs(pairsValue: string, monitorId: string): string | null {
  let pairs = pairsValue.split('\n').filter(Boolean);
  for (let pair of pairs) {
    let [key, ...rest] = pair.split(':');
    if (key === monitorId) {
      return rest.join(':');
    }
  }
  return null;
}

/**
 * Checks if a monitor status matches the current filter value.
 * "Unreviewed" is special: it matches both null/undefined/empty and the explicit 'unreviewed' value,
 * because unreviewed conversations have no status entry in the database.
 */
export function statusMatchesFilter(status: string | null | undefined, filter: string): boolean {
  if (filter === 'unreviewed') {
    return !status || status === 'unreviewed';
  }
  return status === filter;
}

/**
 * Updates (or removes) the value for a given monitorId in a newline-separated
 * "monitorId:value" pairs string. Passing null as value removes the pair.
 */
export function setValueForMonitorPairs(
  pairsValue: string | null,
  monitorId: string,
  value: string | null,
): string {
  let pairs = pairsValue ? pairsValue.split('\n').filter(Boolean) : [];
  let filtered = pairs.filter((pair) => {
    let [key] = pair.split(':');
    return key !== monitorId;
  });
  if (value !== null) {
    filtered.push(`${monitorId}:${value}`);
  }
  return filtered.join('\n');
}
